module.exports = "<footer class=\"footer\">\n        <div class=\"container-fluid\">\n          <p class=\"copyright pull-right\">\n            {{$ctrl.year}}\n            <a href=\"http://www.confident.mu\">Confident Asset Management Limited</a>\n          </p>\n        </div>\n      </footer>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer.html
// module id = 1342
// module chunks = 0